export const ALL_CATEGORIES = 'all';
export const HIDDEN_ASSETS_CATEGORY = 'hidden-assets';
